<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">专家消费明细</div>
          <span class="m-title-s">对用户专家消费情况管理等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-search-wrap">
        <el-form :inline="true" :model="searchForm" ref="searchForm">
          <el-form-item label="省-合作商:" size="mini">
            <el-select v-model="searchForm.proviceCoopId" filterable placeholder="请选择" @change="changeProvice">
              <el-option
                v-for="(item, index) in proviceCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市-合作商:" size="mini">
            <el-select v-model="searchForm.cooperatorId" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in coopList"
                :key="index"
                :label="item.cooperatorName + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户电话:" size="mini">
            <el-input type="text" v-model="searchForm.phone"  placeholder="搜索用户电话" />
          </el-form-item>
          <el-form-item label="时间范围:" size="mini">
            <el-date-picker
              v-model="pickerTime"
              type="datetimerange"
              :default-time="['00:00:00','23:59:59']"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onPickerChange"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: 30px;" size="mini">
            <el-button type="primary" @click="listDataSerch()">搜索</el-button>
            <el-button type="primary" plain @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>消费列表
          </div>
          <div class="m-table-btn">
            <div class="m-total">
              <div class="m-total-item">
                <div>业绩总额：{{ allMoney }} 元</div>
                <div class="m-total-item-tip">未选择查询时间段时，数据均为累积总数</div>
              </div>
              <div class="m-total-item">
                <div>苹果系统业绩额：{{ iosMoney }} 元</div>
                <div class="m-total-item-tip">未选择查询时间段时，数据均为累积总数</div>
              </div>
              <div class="m-total-item">
                <div>安卓系统业绩额：{{ androidMoney }} 元</div>
                <div class="m-total-item-tip">未选择查询时间段时，数据均为累积总数</div>
              </div>
<!--              <div class="m-total-item m-total-new">本月消费总数：{{ newPay }} 元</div>-->
            </div>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
          <el-table-column prop="tradeNo" label="订单号" width="300"></el-table-column>
          <el-table-column prop="description" label="购买服务" width=""></el-table-column>
          <el-table-column prop="phone" label="用户电话" width="130" align="center"></el-table-column>
          <el-table-column prop="payMoney" label="支付金额" width="80" align="center">
            <template slot-scope="scope">
              <div style="color: #ff4d51;">
                {{ scope.row.payMoney }} 元
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付类型" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.payType === 'ios'" size="mini" type="success">苹果支付</el-tag>
              <el-tag v-else size="mini">安卓支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="购买内容" width="" align="center"></el-table-column>
          <el-table-column prop="payDate" label="支付时间" width="" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="" align="center"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import getTime from '../../util/common'
export default {
  name: 'userExpertBuy',
  data () {
    return {
      openState: false,
      formLoading: false,
      isLoading: true,
      specialLoading: false,
      teamLoading: false,
      salesmanLoading: false,
      list: [],
      coopList: [],
      proviceCoopList: [], // 省级合作商选项
      specialCoopList: [], // 省特派员选项
      teamCoopList: [], // 团队长选项
      salesmanCoopList: [], // 业务员选项
      total: 0,
      allMoney: 0.0,
      iosMoney: 0.0,
      androidMoney: 0.0,
      newPay: 0,
      searchForm: {
        cityName: '',
        proviceCoopId: '',
        cooperatorId: '',
        phone: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      },
      pickerTime: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    onPickerChange (e) {
      // this.searchForm.startDate = getTime.getTime(e[0])
      // this.searchForm.endDate = getTime.getTime(e[1])
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.searchForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.searchForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    listDataSerch () {
      this.listData()
      this.loadTotal()
    },
    resetForm () {
      this.searchForm = {
        cityName: '',
        proviceCoopId: '',
        cooperatorId: '',
        phone: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      }
      this.pickerTime = ''
      this.listData()
      this.loadTotal()
      this.changeProvice()
    },
    // 用户列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/doctorExpert/expertPayList', _this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 总数
    loadTotal () {
      let _this = this
      this.$axios.post('/doctorExpert/userExpertPayTotal', _this.searchForm)
        .then((res) => {
          _this.allMoney = res.data.allPay > 0 ? res.data.allPay : 0
          _this.iosMoney = res.data.iosPay > 0 ? res.data.iosPay : 0
          _this.androidMoney = res.data.androidPay > 0 ? res.data.androidPay : 0
        })
    },
    // 省级变化时，市，清空
    changeProvice () {
      this.searchForm.cooperatorId = ''
      this.coopList = []
      this.listCoopData()
    },
    // 市级合作商下拉选项
    listCoopData () {
      this.$axios.post('/dropDownList/coopList', {proviceCoopId: this.searchForm.proviceCoopId})
        .then((res) => {
          this.coopList = res.data
        })
    },
    // 省级合作商下拉选项
    proviceCoopData () {
      this.$axios.post('/dropDownList/proviceCoopList')
        .then((res) => {
          this.proviceCoopList = res.data
        })
    }
  },
  mounted () {
    this.listData()
    this.loadTotal()
    this.listCoopData()
    this.proviceCoopData()
  }
}
</script>

<style scoped src="../../assets/css/user.css"></style>



// WEBPACK FOOTER //
// src/components/user/UserExpertBuy.vue